export default {
  esg_data: {
    total_answer_progress: 'Total answer progress',
    shared_companies: 'Shared companies',
    main_title: 'ESG Data share',
    sub_title_answer: 'Answer data',
    create_new_data: 'Create new data',
    answer_list: {
      section_one: 'Enter your own ESG data and share it with your supply chain companies.',
      section_two: 'It can be used to answer surveys from other companies, reducing the burden of repetitive answers. Data can be shared even if it is not all filled in.',
    },
    create_data_modal: {
      title: 'Create data',
      data_name_auto: 'Automatically generated as [Company name]_[Year]_ESG Data',
      standard_explain: 'A dataset that allows you to quickly input basic ESG information.',
      enter_prise_explain: 'A dataset that comprehensively covers a wide range of ESG information.',
    },
    data: 'Data',
    template: 'Template',
    select: '@:upload_common.target_select',
    share_data: 'Share data',
    total_answer_progress_of_esg_data: 'Total answer progress of ESG data',
    share_data_modal: {
      title: '@:esg_data.share_data',
      message_one: 'Enter the email address of the company you wish to share your ESG master with.',
      message_two: 'An invitation link for viewing will be sent.',
      caution_title: '@:settings.cautions_title',
      caution_one: 'It can be shared to accounts of up to three companies.',
      caution_two: 'Once answer data has been shared, it is not possible to update the data.',
      share: 'Share',
    },
    email: '@:settings.user.email',
    message: 'Message',
    sub_title_share: 'Share data',
    shared_date: 'Shared date',
    unshare: 'Unshare',
    unshare_data_modal: {
      title: 'Unshare data',
      message: 'Do you want to unshare data with {target} ?',
      unshare: 'Unshare',
    },
    data_name: 'Data name',
    data_count: 'Data count',
    esg_data: 'ESG data',
    category_company: '@:settings.company.title',
    company_name: 'Company name',
    sharing_company: 'Sharing Company',
    invitation_message: 'Invitation link has been sent.\nYou can check the sharing status on the "Share Data" page.',
  },
}
